import { render } from "./or-about-page-content.vue?vue&type=template&id=792826fc&scoped=true&bindings={\"options\":\"data\",\"getFromState\":\"options\"}"
import script from "./or-about-page-content.vue?vue&type=script&lang=js"
export * from "./or-about-page-content.vue?vue&type=script&lang=js"

import "./or-about-page-content.vue?vue&type=style&index=0&id=792826fc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-792826fc"

export default script